import { MetaData } from "@qid/core";
import { Organisation } from "../../organisation";
import { Plan, PlanPricingModel } from "../../plan";
import { User } from "../../user";

export interface OrderPriceBreakup {
  subtotal: number;
  discountAmount: number;
  amountBeforeTax: number;
  taxAmount: number;
  payableAmount: number;
}


export class PlanPurchase extends MetaData {

  plan: Plan

  organisation: Organisation

  user: User

  autoRenews: boolean;

  activationTime: Date;

  expireTime: Date;

  planPricingModel: PlanPricingModel

  familyMembers: number;

  familyPlanPurchase: PlanPurchase[];

  parentPlanPurchase: PlanPurchase

  purchasedByUser

  purchasedByMasterUser

  deactivatedBy: string;

  deactivateRemark: string;

  isExpired: boolean;

  razorpaySubscriptionId: string;

  razorpayShortUrl: string;

  priceBreakup: OrderPriceBreakup;

  /** Linked order that created this purchase (enriched by master plan-purchase read when set). */
  orderId?: string | null;

  constructor() {
    super();
  }


}
